export default {
  SET_product(state, value) {
    state.product = value;
  },
  SET_products(state, value) {
    state.products = value;
  },
};
